import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
 import axios from '../../redux/axios';

const initialState = {
  directorate: [],
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const addDirectorateAsyn = createAsyncThunk(
  'department/adddirectorate',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/department/addDeptType',udata, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const addDirectorateSlice = createSlice({
  name: 'adddirectorate',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateSlice: (state, {payload}) => { 
       state.directorate = [];
       state.isError = false;
       state.isSuccess = false;
       state.errorMessage = '';
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
        [addDirectorateAsyn.fulfilled]: (state, { payload }) => {
          state.directorate = payload.data;
          state.isFetching = false;
          state.isSuccess = true;
          state.errorMessage = payload.message;
          return state;
        },
        [addDirectorateAsyn.pending]: (state) => {
          state.isFetching = true;
        },
        [addDirectorateAsyn.rejected]: (state, { payload }) => {
          state.isFetching = false;
          state.isError = true;
          if(payload){
            state.errorMessage = payload.message;
          }
          else{
            state.errorMessage = 'Internal error';
          }
        }
    },
});

 export const {clearStateSlice} = addDirectorateSlice.actions;

 export function clearState() {
  
  return async (dispatch) => {
    dispatch(clearStateSlice());
  }
}

export const addDirectorateSelector = (state) => state.adddirectorate;

export default addDirectorateSlice.reducer;
